export const aItems = [
  {
    "id": "A1",
    "name": "大邱大学",
    "info": "大邱大学的各种信息",
    "end_date": "第四批次：5月12日-6月22日 第五批次：6月23日-7月25日",
    "dormitory": ""
  },
  {
    "id": "A2",
    "name": "东国大学",
    "info": "信息",
    "end_date": "5月26日-6月30日",
    "dormitory": ""
  },
  {
    "id": "A3",
    "name": "清州大学",
    "info": 1231,
    "end_date": "二批：6月2日-6月27日",
    "dormitory": ""
  },
  {
    "id": "A4",
    "name": "庆云大学",
    "info": 12,
    "end_date": "第三批次：5月26日-6月5日 第四批次：6月23日-7月04日 第五批次：7月21日-8月1日",
    "dormitory": "二人寝4074，三人寝3020，四人寝2718。"
  },
  {
    "id": "A5",
    "name": "江南大学",
    "info": "教育部认证的优秀高校，首尔圈位于京畿道，地铁直达首尔城区，生活成本还比首尔低，不收语言费用。毕业要求TOPIK1级。",
    "end_date": "二批 5月26日-6月10日  三批 6月30日-7月9日",
    "dormitory": ""
  },
  {
    "id": "A6",
    "name": "大真大学",
    "info": "AI翻译授课",
    "end_date": "6月16日-6月19日",
    "dormitory": ""
  },
  {
    "id": "A7",
    "name": "亚洲大学",
    "info": 2,
    "end_date": "6月9日-6月20日",
    "dormitory": ""
  },
  {
    "id": "A8",
    "name": "信韩大学",
    "info": "主校区在议政府市，距离首尔坐地铁30分钟，住宿在东豆川小区，上课在议政府需要来回跑。",
    "end_date": "6月17日-7月4日",
    "dormitory": ""
  },
  {
    "id": "A9",
    "name": "大邱加图立大学",
    "info": 2,
    "end_date": "4月24日-7月15日",
    "dormitory": ""
  },
  {
    "id": "A10",
    "name": "圣公会大学",
    "info": 1,
    "end_date": "6月16日-6月26日",
    "dormitory": ""
  },
  {
    "id": "A11",
    "name": "明知大学",
    "info": "首尔校区在首尔核心地区。",
    "end_date": "",
    "dormitory": ""
  },
  {
    "id": "A12",
    "name": "灵山大学",
    "info": 1,
    "end_date": "",
    "dormitory": ""
  },
  {
    "id": "A13",
    "name": "秋溪艺术大学",
    "info": 1,
    "end_date": "",
    "dormitory": ""
  },
  {
    "id": "A14",
    "name": "启明大学",
    "info": 1,
    "end_date": "6月23日-7月4日",
    "dormitory": ""
  },
  {
    "id": "A15",
    "name": "世明大学",
    "info": 1,
    "end_date": "5月12日-6月30日",
    "dormitory": ""
  },
  {
    "id": "A16",
    "name": "建国大学",
    "info": 1,
    "end_date": "5月26日-6月9日",
    "dormitory": ""
  },
  {
    "id": "A17",
    "name": "江原大学",
    "info": "课堂配了AI翻译设备，不是只有中国人一起上课",
    "end_date": "5月30日截止",
    "dormitory": ""
  },
  {
    "id": "A18",
    "name": "京福大学",
    "info": 1,
    "end_date": "",
    "dormitory": ""
  },
  {
    "id": "A19",
    "name": "又石大学",
    "info": 1,
    "end_date": "二批 5月19日-5月30日  三批 6月19日-7月10日",
    "dormitory": ""
  },
  {
    "id": "A20",
    "name": "釜山外国语大学",
    "info": 1,
    "end_date": "二批 5月26日-6月13日",
    "dormitory": ""
  },
  {
    "id": "A21",
    "name": "全州大学",
    "info": 1,
    "end_date": "二批 5月28日-6月6日",
    "dormitory": ""
  },
  {
    "id": "A22",
    "name": "白石大学",
    "info": 1,
    "end_date": "7月18日截止",
    "dormitory": ""
  },
  {
    "id": "A23",
    "name": "忠北保健科学大学",
    "info": "护理类专业不要求护理资格证，有的话可以反3k",
    "end_date": "5月19日-6月19日",
    "dormitory": ""
  },
  {
    "id": "A24",
    "name": "大邱韩医大学",
    "info": "医学类专业排韩国前十。",
    "end_date": "5月1日-6月14日",
    "dormitory": ""
  },
  {
    "id": "A25",
    "name": "乙支大学",
    "info": 1,
    "end_date": "6月18日-7月2日",
    "dormitory": ""
  },
  {
    "id": "A26",
    "name": "东明大学",
    "info": 11,
    "end_date": "6月2日-6月13日",
    "dormitory": ""
  },
  {
    "id": "A27",
    "name": "东新大学",
    "info": 1358,
    "end_date": "5月30日-6月13日",
    "dormitory": ""
  },
  {
    "id": "A28",
    "name": "又松大学",
    "info": 1449,
    "end_date": "二批6月2日-6月13日 三批6月30日-7月11日",
    "dormitory": ""
  },
  {
    "id": "A29",
    "name": "牧园大学",
    "info": 3552,
    "end_date": "5月截止报名",
    "dormitory": ""
  },
  {
    "id": "A30",
    "name": "庆一大学",
    "info": 3553,
    "end_date": "",
    "dormitory": ""
  },
  {
    "id": "A31",
    "name": "圣洁大学",
    "info": 3554,
    "end_date": "5月14日-5月30日",
    "dormitory": ""
  },
  {
    "id": "A32",
    "name": "中部大学",
    "info": "",
    "end_date": "3月10日-6月20日",
    "dormitory": ""
  },
  {
    "id": "A33",
    "name": "尚志大学",
    "info": "",
    "end_date": "随时可申",
    "dormitory": ""
  }
];
export const bItems = [
  {
    "id": "B1",
    "name": "经营·管理",
    "info": "管理学士",
    "connections": [
      {
        "a": "A1",
        "c": "C1",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C2",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C15",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C22",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C26",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C98",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C151",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C157",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C178",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C188",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C191",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C199",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C206",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C232",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C246",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C251",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C261",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C265",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C291",
        "key": ""
      }
    ]
  },
  {
    "id": "B2",
    "name": "酒店管理",
    "info": "工商管理（酒店旅游管理）学士",
    "connections": [
      {
        "a": "A3",
        "c": "C29",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C134",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C252",
        "key": ""
      }
    ]
  },
  {
    "id": "B3",
    "name": "会计",
    "info": "工商管理学学士，专业领域：会计/大邱是会计学学士",
    "connections": [
      {
        "a": "A2",
        "c": "C21",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C27",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C97",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C189",
        "key": ""
      }
    ]
  },
  {
    "id": "B4",
    "name": "国际贸易",
    "info": "经济金融学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C3",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C86",
        "key": ""
      },
      {
        "a": "A11",
        "c": "C132",
        "key": ""
      }
    ]
  },
  {
    "id": "B5",
    "name": "艺术设计",
    "info": "设计学学士",
    "connections": [
      {
        "a": "A2",
        "c": "C16",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C38",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C39",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C40",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C41",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C42",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C43",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C62",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C66",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C87",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C126",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C127",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C128",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C129",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C137",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C138",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C139",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C140",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C161",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C177",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C187",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C211",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C225",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C235",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C236",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C258",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C267",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C282",
        "key": ""
      }
    ]
  },
  {
    "id": "B6",
    "name": "多媒体",
    "info": "",
    "connections": [
      {
        "a": "A6",
        "c": "C75",
        "key": ""
      },
      {
        "a": "A11",
        "c": "C133",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C254",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C257",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C284",
        "key": ""
      }
    ]
  },
  {
    "id": "B7",
    "name": "计算机",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C7",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C33",
        "key": ""
      },
      {
        "a": "A7",
        "c": "C77",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C82",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C89",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C112",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C113",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C114",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C115",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C146",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C160",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C162",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C175",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C185",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C190",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C192",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C230",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C231",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C233",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C239",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C255",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C262",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C268",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C278",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C279",
        "key": ""
      }
    ]
  },
  {
    "id": "B8",
    "name": "机械工学 ",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C9",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C83",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C108",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C142",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C155",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C194",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C240",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C269",
        "key": ""
      }
    ]
  },
  {
    "id": "B9",
    "name": "电气·电子·信息",
    "info": "电子·信息通信工学 工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C11",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C18",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C36",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C37",
        "key": ""
      },
      {
        "a": "A6",
        "c": "C76",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C107",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C110",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C143",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C144",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C154",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C280",
        "key": ""
      }
    ]
  },
  {
    "id": "B10",
    "name": "生物制药",
    "info": "生物制药工学",
    "connections": [
      {
        "a": "A2",
        "c": "C17",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C44",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C101",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C209",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C270",
        "key": ""
      }
    ]
  },
  {
    "id": "B11",
    "name": "护理学",
    "info": "包含护理学等",
    "connections": [
      {
        "a": "A4",
        "c": "C45",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C201",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C207",
        "key": ""
      }
    ]
  },
  {
    "id": "B12",
    "name": "保健康复",
    "info": "包含保健康复等",
    "connections": [
      {
        "a": "A4",
        "c": "C46",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C47",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C48",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C49",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C88",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C102",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C103",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C104",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C147",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C168",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C169",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C183",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C202",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C204",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C205",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C208",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C212",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C213",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C214",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C215",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C216",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C217",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C220",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C221",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C228",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C234",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C241",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C243",
        "key": ""
      }
    ]
  },
  {
    "id": "B13",
    "name": "医疗经营",
    "info": "工商管理学士·医疗服务管理",
    "connections": [
      {
        "a": "A4",
        "c": "C50",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C106",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C224",
        "key": ""
      }
    ]
  },
  {
    "id": "B14",
    "name": "航空经营",
    "info": "工商管理（航空经营）",
    "connections": [
      {
        "a": "A4",
        "c": "C51",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C52",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C95",
        "key": ""
      }
    ]
  },
  {
    "id": "B15",
    "name": "航空工学",
    "info": "",
    "connections": [
      {
        "a": "A4",
        "c": "C53",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C54",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C55",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C56",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C57",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C58",
        "key": ""
      }
    ]
  },
  {
    "id": "B16",
    "name": "新闻广播",
    "info": "新闻学学士",
    "connections": [
      {
        "a": "A3",
        "c": "C30",
        "key": ""
      }
    ]
  },
  {
    "id": "B17",
    "name": "建筑工学",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C8",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C34",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C35",
        "key": ""
      },
      {
        "a": "A6",
        "c": "C74",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C111",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C145",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C238",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C253",
        "key": ""
      }
    ]
  },
  {
    "id": "B18",
    "name": "国际地域",
    "info": "国际区域学学士",
    "connections": [
      {
        "a": "A6",
        "c": "C69",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C92",
        "key": ""
      }
    ]
  },
  {
    "id": "B19",
    "name": "国际语言",
    "info": "文学学士（汉语言）",
    "connections": [
      {
        "a": "A1",
        "c": "C13",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C14",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C32",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C93",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C94",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C152",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C166",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C264",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C271",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C272",
        "key": ""
      }
    ]
  },
  {
    "id": "B20",
    "name": "媒体传播",
    "info": "新闻学学士",
    "connections": [
      {
        "a": "A9",
        "c": "C120",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C121",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C237",
        "key": ""
      }
    ]
  },
  {
    "id": "B21",
    "name": "音乐学",
    "info": "音乐学学士（实用音乐）",
    "connections": [
      {
        "a": "A5",
        "c": "C67",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C125",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C141",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C149",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C176",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C249",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C281",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C283",
        "key": ""
      }
    ]
  },
  {
    "id": "B22",
    "name": "美术",
    "info": "美术学",
    "connections": [
      {
        "a": "A13",
        "c": "C148",
        "key": ""
      }
    ]
  },
  {
    "id": "B23",
    "name": "舞蹈",
    "info": "舞蹈学",
    "connections": [
      {
        "a": "A13",
        "c": "C150",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C153",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C250",
        "key": ""
      }
    ]
  },
  {
    "id": "B24",
    "name": "法学",
    "info": "法学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C4",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C31",
        "key": ""
      },
      {
        "a": "A6",
        "c": "C72",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C158",
        "key": ""
      }
    ]
  },
  {
    "id": "B25",
    "name": "食品营养",
    "info": "理学学士 世明 工学",
    "connections": [
      {
        "a": "A9",
        "c": "C99",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C100",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C159",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C170",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C210",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C218",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C219",
        "key": ""
      }
    ]
  },
  {
    "id": "B26",
    "name": "物流经营",
    "info": "",
    "connections": [
      {
        "a": "A12",
        "c": "C136",
        "key": ""
      }
    ]
  },
  {
    "id": "B27",
    "name": "观光会展学",
    "info": "",
    "connections": [
      {
        "a": "A12",
        "c": "C135",
        "key": ""
      }
    ]
  },
  {
    "id": "B28",
    "name": "美妆时尚造型",
    "info": "艺术学学士",
    "connections": [
      {
        "a": "A8",
        "c": "C84",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C244",
        "key": ""
      }
    ]
  },
  {
    "id": "B29",
    "name": "运动体育健康",
    "info": "体育学士",
    "connections": [
      {
        "a": "A2",
        "c": "C19",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C20",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C23",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C61",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C85",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C105",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C167",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C186",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C203",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C223",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C247",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C248",
        "key": ""
      }
    ]
  },
  {
    "id": "B30",
    "name": "保安警护学",
    "info": "",
    "connections": [
      {
        "a": "A4",
        "c": "C60",
        "key": ""
      }
    ]
  },
  {
    "id": "B31",
    "name": "公共行政",
    "info": "管理学士（公共行政）",
    "connections": [
      {
        "a": "A17",
        "c": "C163",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C275",
        "key": ""
      }
    ]
  },
  {
    "id": "B32",
    "name": "园林设计",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C10",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C182",
        "key": ""
      }
    ]
  },
  {
    "id": "B33",
    "name": "园林学",
    "info": "理学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C12",
        "key": ""
      }
    ]
  },
  {
    "id": "B34",
    "name": "旅游学",
    "info": "旅游学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C5",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C6",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C184",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C273",
        "key": ""
      }
    ]
  },
  {
    "id": "B35",
    "name": "医疗保健护理",
    "info": "保健学学士",
    "connections": [
      {
        "a": "A2",
        "c": "C25",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C81",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C90",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C174",
        "key": ""
      }
    ]
  },
  {
    "id": "B36",
    "name": "幼儿融合教育",
    "info": "教育学",
    "connections": [
      {
        "a": "A8",
        "c": "C78",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C165",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C173",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C288",
        "key": ""
      }
    ]
  },
  {
    "id": "B37",
    "name": "国际经营",
    "info": "经营学",
    "connections": [
      {
        "a": "A5",
        "c": "C63",
        "key": ""
      },
      {
        "a": "A6",
        "c": "C70",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C79",
        "key": ""
      },
      {
        "a": "A16",
        "c": "C171",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C197",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C259",
        "key": ""
      }
    ]
  },
  {
    "id": "B38",
    "name": "汽车机械",
    "info": "工学学士",
    "connections": []
  },
  {
    "id": "B39",
    "name": "媒体传播",
    "info": "媒体学",
    "connections": [
      {
        "a": "A6",
        "c": "C71",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C80",
        "key": ""
      },
      {
        "a": "A16",
        "c": "C172",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C181",
        "key": ""
      }
    ]
  },
  {
    "id": "B40",
    "name": "人工智能",
    "info": "理学",
    "connections": []
  },
  {
    "id": "B41",
    "name": "儿童教育",
    "info": "理学",
    "connections": [
      {
        "a": "A6",
        "c": "C68",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C118",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C179",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C226",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C227",
        "key": ""
      }
    ]
  },
  {
    "id": "B42",
    "name": "教育专业",
    "info": "",
    "connections": [
      {
        "a": "A9",
        "c": "C91",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C124",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C180",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C266",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C287",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C289",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C290",
        "key": ""
      }
    ]
  },
  {
    "id": "B43",
    "name": "医疗工学",
    "info": "",
    "connections": [
      {
        "a": "A14",
        "c": "C156",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C222",
        "key": ""
      }
    ]
  },
  {
    "id": "B44",
    "name": "经济金融",
    "info": "",
    "connections": [
      {
        "a": "A17",
        "c": "C164",
        "key": ""
      }
    ]
  },
  {
    "id": "B45",
    "name": "航空服务",
    "info": "",
    "connections": [
      {
        "a": "A21",
        "c": "C195",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C198",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C260",
        "key": ""
      }
    ]
  },
  {
    "id": "B46",
    "name": "化妆美容",
    "info": "",
    "connections": [
      {
        "a": "A29",
        "c": "C263",
        "key": ""
      }
    ]
  },
  {
    "id": "B47",
    "name": "管理专业",
    "info": "",
    "connections": [
      {
        "a": "A31",
        "c": "C274",
        "key": ""
      }
    ]
  },
  {
    "id": "B99",
    "name": "其他",
    "info": "",
    "connections": [
      {
        "a": "A2",
        "c": "C24",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C28",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C59",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C64",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C65",
        "key": ""
      },
      {
        "a": "A6",
        "c": "C73",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C96",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C109",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C116",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C117",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C119",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C122",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C123",
        "key": ""
      },
      {
        "a": "A10",
        "c": "C130",
        "key": ""
      },
      {
        "a": "A10",
        "c": "C131",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C193",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C196",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C200",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C229",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C242",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C245",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C256",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C276",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C277",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C285",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C286",
        "key": ""
      }
    ]
  }
];
export const cItems = [
  {
    "id": "C1",
    "name": "经营学",
    "info": "B1_A1",
    "extra_info": "39632元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C2",
    "name": "会计学",
    "info": "B1_A1",
    "extra_info": "39632元",
    "info2": "会计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C3",
    "name": "国际贸易",
    "info": "B4_A1",
    "extra_info": "39632元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C4",
    "name": "法学",
    "info": "B24_A1",
    "extra_info": "39632元",
    "info2": "法学学士",
    "no_prerequisites": false
  },
  {
    "id": "C5",
    "name": "旅游管理",
    "info": "B34_A1",
    "extra_info": "39632元",
    "info2": "旅游学学士",
    "no_prerequisites": false
  },
  {
    "id": "C6",
    "name": "旅游航空经营",
    "info": "B34_A1",
    "extra_info": "39632元",
    "info2": "旅游学学士",
    "no_prerequisites": true
  },
  {
    "id": "C7",
    "name": "网络信息安全",
    "info": "B7_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C8",
    "name": "建筑工学",
    "info": "B17_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C9",
    "name": "机械工学",
    "info": "B8_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C10",
    "name": "园林造景设计",
    "info": "B32_A1",
    "extra_info": "53518元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C11",
    "name": "电气工学",
    "info": "B9_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C12",
    "name": "园林学",
    "info": "B33_A1",
    "extra_info": "50832元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C13",
    "name": "国际语言",
    "info": "B19_A1",
    "extra_info": "39532元",
    "info2": "文学学士",
    "no_prerequisites": true
  },
  {
    "id": "C14",
    "name": "汉语言文学",
    "info": "B19_A2",
    "extra_info": "34550元",
    "info2": "文学学士",
    "no_prerequisites": true
  },
  {
    "id": "C15",
    "name": "经营学",
    "info": "B1_A2",
    "extra_info": "34550元",
    "info2": "工商管理学学士",
    "no_prerequisites": true
  },
  {
    "id": "C16",
    "name": "设计美术",
    "info": "B5_A2",
    "extra_info": "45496元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C17",
    "name": "*生物制药工学",
    "info": "B10_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C18",
    "name": "*电子·信息通信工学",
    "info": "B9_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C19",
    "name": "*体育科学",
    "info": "B29_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C20",
    "name": "*体育医学",
    "info": "B29_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C21",
    "name": "*会计税务学",
    "info": "B3_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C22",
    "name": "*信息经营学",
    "info": "B1_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C23",
    "name": "*酒店观光经营学",
    "info": "B29_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C24",
    "name": "*料理外食经营学",
    "info": "B99_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C25",
    "name": "*医疗美容学",
    "info": "B35_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C26",
    "name": "经营学",
    "info": "B1_A3",
    "extra_info": "36352元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C27",
    "name": "会计学",
    "info": "B3_A3",
    "extra_info": "36352元",
    "info2": "会计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C28",
    "name": "经济通商",
    "info": "B99_A3",
    "extra_info": "36352元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C29",
    "name": "酒店外食经营",
    "info": "B2_A3",
    "extra_info": "36352元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C30",
    "name": "新闻广播",
    "info": "B16_A3",
    "extra_info": "36352元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C31",
    "name": "法学",
    "info": "B24_A3",
    "extra_info": "36352元",
    "info2": "法学学士",
    "no_prerequisites": false
  },
  {
    "id": "C32",
    "name": "英语英文",
    "info": "B19_A3",
    "extra_info": "36352元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C33",
    "name": "人工智能软件",
    "info": "B7_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C34",
    "name": "城市造景",
    "info": "B17_A3",
    "extra_info": "41493元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C35",
    "name": "建筑工程",
    "info": "B17_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C36",
    "name": "电子工程",
    "info": "B9_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C37",
    "name": "电气控制工程",
    "info": "B9_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C38",
    "name": "视觉设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C39",
    "name": "工艺设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C40",
    "name": "艺术与时尚设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C41",
    "name": "数字媒体设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C42",
    "name": "漫画动漫",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "艺术学学士",
    "no_prerequisites": false
  },
  {
    "id": "C43",
    "name": "电影影像",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C44",
    "name": "生物制药医疗学",
    "info": "B10_A3",
    "extra_info": "43555元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C45",
    "name": "护理学",
    "info": "B11_A4",
    "extra_info": "39050元",
    "info2": "护理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C46",
    "name": "物理治疗学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C47",
    "name": "作业治疗学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C48",
    "name": "牙齿卫生学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "牙齿卫生学士",
    "no_prerequisites": false
  },
  {
    "id": "C49",
    "name": "临床病理学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "理学学士，专业方向为医学检验技术，病理技术，分子检测，助产，卫生检验和检疫。",
    "no_prerequisites": false
  },
  {
    "id": "C50",
    "name": "医疗经营学",
    "info": "B13_A4",
    "extra_info": "30300元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C51",
    "name": "航空交流物流学",
    "info": "B14_A4",
    "extra_info": "39050元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C52",
    "name": "航空观光服务学",
    "info": "B14_A4",
    "extra_info": "30300元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C53",
    "name": "航空机械工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C54",
    "name": "航空电子工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C55",
    "name": "航空情报工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C56",
    "name": "（已删除内容）新素材工学",
    "info": "B100_A100",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C57",
    "name": "航空软件工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C58",
    "name": "无人机工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C59",
    "name": "安全防灾工学",
    "info": "B99_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C60",
    "name": "（已删除内容）保安警护学",
    "info": "B100_A100",
    "extra_info": "39300元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C61",
    "name": "运动体育健康学",
    "info": "B29_A4",
    "extra_info": "39300元",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C62",
    "name": "多媒体设计动漫学",
    "info": "B5_A4",
    "extra_info": "41800元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C63",
    "name": "经营学",
    "info": "B37_A5",
    "extra_info": "52400元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C64",
    "name": "社会事业学",
    "info": "B99_A5",
    "extra_info": "52400元",
    "info2": "社会福利学学士",
    "no_prerequisites": false
  },
  {
    "id": "C65",
    "name": "体育福利专业",
    "info": "B99_A5",
    "extra_info": "60600元",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C66",
    "name": "环球艺术设计专业",
    "info": "B5_A5",
    "extra_info": "67000元",
    "info2": "美术设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C67",
    "name": "音乐学专业",
    "info": "B21_A5",
    "extra_info": "67000元",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C68",
    "name": "儿童学",
    "info": "B41_A6",
    "extra_info": "31500元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C69",
    "name": "国际地域学",
    "info": "B18_A6",
    "extra_info": "41200元",
    "info2": "国际区域学学士",
    "no_prerequisites": false
  },
  {
    "id": "C70",
    "name": "国际经营学",
    "info": "B37_A6",
    "extra_info": "31500元",
    "info2": "教育学学士",
    "no_prerequisites": true
  },
  {
    "id": "C71",
    "name": "视觉传达专业",
    "info": "B39_A6",
    "extra_info": "41200元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C72",
    "name": "公共人才法学",
    "info": "B24_A6",
    "extra_info": "31500原",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C73",
    "name": "智能融合安保",
    "info": "B99_A6",
    "extra_info": "41200元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C74",
    "name": "建筑工程",
    "info": "B17_A6",
    "extra_info": "41200元",
    "info2": "工学学士",
    "no_prerequisites": true
  },
  {
    "id": "C75",
    "name": "电影影视",
    "info": "B6_A6",
    "extra_info": "41200元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C76",
    "name": "电气工学",
    "info": "B9_A6",
    "extra_info": "41200元",
    "info2": "工学学士",
    "no_prerequisites": true
  },
  {
    "id": "C77",
    "name": "IT专业",
    "info": "B7_A7",
    "extra_info": "52000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C78",
    "name": "幼儿融合教育",
    "info": "B36_A8",
    "extra_info": "",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C79",
    "name": "国际经营学",
    "info": "B37_A8",
    "extra_info": "",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C80",
    "name": "媒体传播学",
    "info": "B39_A8",
    "extra_info": "",
    "info2": "新闻学学士",
    "no_prerequisites": false
  },
  {
    "id": "C81",
    "name": "医疗护理保健",
    "info": "B35_A8",
    "extra_info": "",
    "info2": "保健学学士",
    "no_prerequisites": false
  },
  {
    "id": "C82",
    "name": "软件工程",
    "info": "B7_A8",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C83",
    "name": "机械汽车工学",
    "info": "B8_A8",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C84",
    "name": "美妆时尚造型",
    "info": "B28_A8",
    "extra_info": "",
    "info2": "艺术学学士",
    "no_prerequisites": false
  },
  {
    "id": "C85",
    "name": "体育运动学部",
    "info": "B29_A8",
    "extra_info": "",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C86",
    "name": "全球商务",
    "info": "B4_A9",
    "extra_info": "大邱加图立",
    "info2": "经营，工商管理",
    "no_prerequisites": false
  },
  {
    "id": "C87",
    "name": "媒体设计",
    "info": "B5_A9",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C88",
    "name": "医疗康复 ",
    "info": "B12_A9",
    "extra_info": "",
    "info2": "物理治疗，康复治疗",
    "no_prerequisites": false
  },
  {
    "id": "C89",
    "name": "人工智能计算机",
    "info": "B7_A9",
    "extra_info": "",
    "info2": "人工智能，Ai大数据",
    "no_prerequisites": false
  },
  {
    "id": "C90",
    "name": "医疗美容管理",
    "info": "B35_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C91",
    "name": "国际教育",
    "info": "B42_A9",
    "extra_info": "",
    "info2": "教育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C92",
    "name": "韩国学",
    "info": "B18_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C93",
    "name": "英语专业",
    "info": "B19_A9",
    "extra_info": "",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C94",
    "name": "日语日文",
    "info": "B19_A9",
    "extra_info": "",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C95",
    "name": "全球航空服务",
    "info": "B14_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C96",
    "name": "全球文化信息",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C97",
    "name": "会计税务",
    "info": "B3_A9",
    "extra_info": "",
    "info2": "会计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C98",
    "name": "经营学",
    "info": "B1_A9",
    "extra_info": "",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C99",
    "name": "食品营养专业",
    "info": "B25_A9",
    "extra_info": "",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C100",
    "name": "西餐料理烘培",
    "info": "B25_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C101",
    "name": "制药工学",
    "info": "B10_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C102",
    "name": "语言听觉治疗",
    "info": "B12_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C103",
    "name": "放射线",
    "info": "B12_A9",
    "extra_info": "",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C104",
    "name": "眼睛光学",
    "info": "B12_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C105",
    "name": "生活体育",
    "info": "B29_A9",
    "extra_info": "",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C106",
    "name": "保健医疗经营",
    "info": "B13_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C107",
    "name": "半导体电子工程",
    "info": "B9_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C108",
    "name": "机器人工程",
    "info": "B8_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C109",
    "name": "消防防灾专业",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C110",
    "name": "电气工程系",
    "info": "B9_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C111",
    "name": "建筑工程",
    "info": "B17_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C112",
    "name": "计算机工学专业",
    "info": "B7_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C113",
    "name": "网络安全专业",
    "info": "B7_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C114",
    "name": "游戏工学专业",
    "info": "B7_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C115",
    "name": "软件融合专业",
    "info": "B7_A9",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C116",
    "name": "文献信息专业",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C117",
    "name": "心理专业",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C118",
    "name": "儿童专业",
    "info": "B41_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C119",
    "name": "社会福祉专业",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C120",
    "name": "媒体影响专业",
    "info": "B20_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C121",
    "name": "广告宣传专业",
    "info": "B20_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C122",
    "name": "警察行政专业",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C123",
    "name": "军事学系",
    "info": "B99_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C124",
    "name": "教育专业",
    "info": "B42_A9",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C125",
    "name": "实用音乐专业",
    "info": "B21_A9",
    "extra_info": "",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C126",
    "name": "艺术治疗专业",
    "info": "B5_A9",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C127",
    "name": "产业设计专业",
    "info": "B5_A9",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C128",
    "name": "时装设计专业",
    "info": "B5_A9",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C129",
    "name": "金属珠宝设计专业",
    "info": "B5_A9",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C130",
    "name": "新媒体艺术管理",
    "info": "B99_A10",
    "extra_info": "圣公会大学",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C131",
    "name": "企业数字化管理",
    "info": "B99_A10",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C132",
    "name": "国际商务",
    "info": "B4_A11",
    "extra_info": "明知大学",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C133",
    "name": "电影",
    "info": "B6_A11",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C134",
    "name": "酒店经营学",
    "info": "B2_A12",
    "extra_info": "灵山大学",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C135",
    "name": "观光会展学",
    "info": "B27_A12",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C136",
    "name": "物流经营",
    "info": "B26_A12",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C137",
    "name": "美容艺术学",
    "info": "B5_A12",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C138",
    "name": "服装设计",
    "info": "B5_A12",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C139",
    "name": "室内环境设计",
    "info": "B5_A12",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C140",
    "name": "演艺公演艺术",
    "info": "B5_A12",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C141",
    "name": "实用音乐专业",
    "info": "B21_A12",
    "extra_info": "",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C142",
    "name": "机械汽车工学",
    "info": "B8_A12",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C143",
    "name": "氢系统工学",
    "info": "B9_A12",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C144",
    "name": "电气电子工学",
    "info": "B9_A12",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C145",
    "name": "建筑工学",
    "info": "B17_A12",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C146",
    "name": "计算机工学",
    "info": "B7_A12",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C147",
    "name": "口腔卫生学",
    "info": "B12_A12",
    "extra_info": "",
    "info2": "口腔卫生学学士",
    "no_prerequisites": false
  },
  {
    "id": "C148",
    "name": "美术学",
    "info": "B22_A13",
    "extra_info": "秋溪艺术大学",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C149",
    "name": "音乐学",
    "info": "B21_A13",
    "extra_info": "",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C150",
    "name": "舞蹈学",
    "info": "B23_A13",
    "extra_info": "",
    "info2": "舞蹈学学士",
    "no_prerequisites": false
  },
  {
    "id": "C151",
    "name": "观光经营",
    "info": "B1_A14",
    "extra_info": "启明大学",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C152",
    "name": "中文",
    "info": "B19_A14",
    "extra_info": "",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C153",
    "name": "舞蹈系",
    "info": "B23_A14",
    "extra_info": "",
    "info2": "舞蹈学学士",
    "no_prerequisites": false
  },
  {
    "id": "C154",
    "name": "电气工学",
    "info": "B9_A14",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C155",
    "name": "汽车工学",
    "info": "B8_A14",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C156",
    "name": "医用工学",
    "info": "B43_A14",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C157",
    "name": "经营学",
    "info": "B1_A15",
    "extra_info": "世明大学",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C158",
    "name": "法学",
    "info": "B24_A15",
    "extra_info": "",
    "info2": "法学学士",
    "no_prerequisites": false
  },
  {
    "id": "C159",
    "name": "食品营养专业",
    "info": "B25_A15",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C160",
    "name": "计算机",
    "info": "B7_A15",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C161",
    "name": "视觉设计",
    "info": "B5_A15",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C162",
    "name": "人工智能软件",
    "info": "B7_A17",
    "extra_info": "江原大学",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C163",
    "name": "公共行政",
    "info": "B31_A17",
    "extra_info": "",
    "info2": "管理学士（公共行政）",
    "no_prerequisites": false
  },
  {
    "id": "C164",
    "name": "经济金融",
    "info": "B44_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C165",
    "name": "幼儿教育",
    "info": "B36_A17",
    "extra_info": "",
    "info2": "教育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C166",
    "name": "英语专业",
    "info": "B19_A17",
    "extra_info": "",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C167",
    "name": "人类体育系",
    "info": "B29_A17",
    "extra_info": "",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C168",
    "name": "物理治疗系",
    "info": "B12_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C169",
    "name": "眼睛光学系",
    "info": "B12_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C170",
    "name": "食品营养学",
    "info": "B25_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C171",
    "name": "国际经营学",
    "info": "B37_A16",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C172",
    "name": "传媒影像",
    "info": "B39_A16",
    "extra_info": "",
    "info2": "传媒学学士",
    "no_prerequisites": false
  },
  {
    "id": "C173",
    "name": "幼儿教育",
    "info": "B36_A18",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C174",
    "name": "医疗美容 ",
    "info": "B35_A18",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C175",
    "name": "软件融合专业",
    "info": "B7_A18",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C176",
    "name": "实用音乐专业",
    "info": "B21_A18",
    "extra_info": "",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C177",
    "name": "视觉设计",
    "info": "B5_A18",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C178",
    "name": "经营学",
    "info": "B1_A19",
    "extra_info": "",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C179",
    "name": "儿童福祉教育",
    "info": "B41_A19",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C180",
    "name": "幼儿特殊教育",
    "info": "B42_A19",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C181",
    "name": "传媒影像",
    "info": "B39_A19",
    "extra_info": "",
    "info2": "传媒学？新闻学？",
    "no_prerequisites": false
  },
  {
    "id": "C182",
    "name": "造景学",
    "info": "B32_A19",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C183",
    "name": "康复咨询",
    "info": "B12_A19",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C184",
    "name": "旅游管理",
    "info": "B34_A19",
    "extra_info": "",
    "info2": "旅游学学士",
    "no_prerequisites": false
  },
  {
    "id": "C185",
    "name": "计算机工程",
    "info": "B7_A19",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C186",
    "name": "生活体育",
    "info": "B29_A19",
    "extra_info": "",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C187",
    "name": "时尚设计",
    "info": "B5_A19",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C188",
    "name": "经营专业",
    "info": "B1_A20",
    "extra_info": "",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C189",
    "name": "会计专业",
    "info": "B3_A20",
    "extra_info": "",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C190",
    "name": "计算机工学专业",
    "info": "B7_A20",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C191",
    "name": "经营学",
    "info": "B1_A21",
    "extra_info": "",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C192",
    "name": "人工智能学",
    "info": "B7_A21",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C193",
    "name": "产业设计专业",
    "info": "B99_A21",
    "extra_info": "",
    "info2": "设计学士",
    "no_prerequisites": false
  },
  {
    "id": "C194",
    "name": "机械工学",
    "info": "B8_A21",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C195",
    "name": "航空乘务专业",
    "info": "B45_A21",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C196",
    "name": "全球文化交流",
    "info": "B99_A21",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C197",
    "name": "国际贸易学",
    "info": "B37_A22",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C198",
    "name": "航空服务",
    "info": "B45_A22",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C199",
    "name": "体育经营",
    "info": "B1_A22",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C200",
    "name": "音乐剧",
    "info": "B99_A22",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C201",
    "name": "护理学",
    "info": "B11_A23",
    "extra_info": "",
    "info2": "护理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C202",
    "name": "*临床病理学",
    "info": "B12_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C203",
    "name": "*体育科学",
    "info": "B29_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C204",
    "name": "*医疗保健学",
    "info": "B12_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C205",
    "name": "*保健学",
    "info": "B12_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C206",
    "name": "*经营学",
    "info": "B1_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C207",
    "name": "护理学",
    "info": "B11_A24",
    "extra_info": "",
    "info2": "护理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C208",
    "name": "临床病理",
    "info": "B12_A24",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C209",
    "name": "制药工学",
    "info": "B10_A24",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C210",
    "name": "食品营养",
    "info": "B25_A24",
    "extra_info": "",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C211",
    "name": "室内建筑设计",
    "info": "B5_A24",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C212",
    "name": "临床病理系",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C213",
    "name": "眼睛光学",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C214",
    "name": "应急救护",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C215",
    "name": "放射线",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C216",
    "name": "口腔卫生学",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "口腔卫生学学士",
    "no_prerequisites": false
  },
  {
    "id": "C217",
    "name": "物理治疗",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C218",
    "name": "食品营养",
    "info": "B25_A25",
    "extra_info": "",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C219",
    "name": "食品产业外食",
    "info": "B25_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C220",
    "name": "保健环境安全",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C221",
    "name": "美容化妆品科学",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C222",
    "name": "医疗工学",
    "info": "B43_A25",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C223",
    "name": "户外运动",
    "info": "B29_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C224",
    "name": "医疗经营学",
    "info": "B13_A25",
    "extra_info": "",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C225",
    "name": "医疗宣传设计",
    "info": "B5_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C226",
    "name": "儿童系",
    "info": "B41_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C227",
    "name": "幼儿教育系",
    "info": "B41_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C228",
    "name": "中毒康复福祉",
    "info": "B12_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C229",
    "name": "葬礼指导",
    "info": "B99_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C230",
    "name": "医疗IT",
    "info": "B7_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C231",
    "name": "大数据医疗融合",
    "info": "B7_A25",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C232",
    "name": "经营",
    "info": "B1_A26",
    "extra_info": "",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C233",
    "name": "游戏工程",
    "info": "B7_A26",
    "extra_info": "",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C234",
    "name": "美容护理",
    "info": "B12_A26",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C235",
    "name": "视觉设计",
    "info": "B5_A26",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C236",
    "name": "服装设计",
    "info": "B5_A26",
    "extra_info": "",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C237",
    "name": "新媒体传播",
    "info": "B20_A26",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C238",
    "name": "建筑学系",
    "info": "B17_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C239",
    "name": "计算机工程系",
    "info": "B7_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C240",
    "name": "电气工程系",
    "info": "B8_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C241",
    "name": "眼视光学系",
    "info": "B12_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C242",
    "name": "伴侣动物学系",
    "info": "B99_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C243",
    "name": "运动医学系",
    "info": "B12_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C244",
    "name": "美容美发学系",
    "info": "B28_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C245",
    "name": "心理咨询学系",
    "info": "B99_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C246",
    "name": "经营学系",
    "info": "B1_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C247",
    "name": "生活体育学系",
    "info": "B29_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C248",
    "name": "跆拳道学系",
    "info": "B29_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C249",
    "name": "音乐剧实用音乐学系",
    "info": "B21_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C250",
    "name": "公演艺术舞蹈学系",
    "info": "B23_A27",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C251",
    "name": "经营学",
    "info": "B1_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C252",
    "name": "酒店观光经营",
    "info": "B2_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C253",
    "name": "建筑工学",
    "info": "B17_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C254",
    "name": "媒体设计影像",
    "info": "B6_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C255",
    "name": "计算机工学",
    "info": "B7_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C256",
    "name": "物流系统",
    "info": "B99_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C257",
    "name": "游戏多媒体",
    "info": "B6_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C258",
    "name": "形象设计",
    "info": "B5_A28",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C259",
    "name": "国际商务",
    "info": "B37_A29",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C260",
    "name": "航空酒店管理",
    "info": "B45_A29",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C261",
    "name": "经营学",
    "info": "B1_A29",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C262",
    "name": "计算机工学",
    "info": "B7_A29",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C263",
    "name": "化妆品美容学",
    "info": "B46_A29",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C264",
    "name": "中国语言文学",
    "info": "B19_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C265",
    "name": "经营学",
    "info": "B1_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C266",
    "name": "教育学",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C267",
    "name": "美容设计",
    "info": "B5_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C268",
    "name": "计算机科学",
    "info": "B7_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C269",
    "name": "新时代媒体（媒体科学技术）",
    "info": "B8_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C270",
    "name": "生物化妆品工程学",
    "info": "B10_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C271",
    "name": "韩国语言文学",
    "info": "B19_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C272",
    "name": "英国语言文学",
    "info": "B19_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C273",
    "name": "旅游开发",
    "info": "B34_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C274",
    "name": "公共管理",
    "info": "B47_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C275",
    "name": "行政学",
    "info": "B31_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C276",
    "name": "物流管理",
    "info": "B99_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C277",
    "name": "产品管理工程",
    "info": "B99_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C278",
    "name": "信息通信工程",
    "info": "B7_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C279",
    "name": "媒体软件",
    "info": "B7_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C280",
    "name": "城市设计信息工程",
    "info": "B9_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C281",
    "name": "音乐学",
    "info": "B21_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C282",
    "name": "美容设计",
    "info": "B5_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C283",
    "name": "应用音乐",
    "info": "B21_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C284",
    "name": "戏剧与电影",
    "info": "B6_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C285",
    "name": "表演艺术",
    "info": "B99_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C286",
    "name": "商谈心理学",
    "info": "B99_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C287",
    "name": "教育学",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C288",
    "name": "幼儿教育",
    "info": "B36_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C289",
    "name": "体育教育",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C290",
    "name": "戏剧与电影教育",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C291",
    "name": "经营学",
    "info": "B42_A32",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C292",
    "name": "（只有大三）福利商谈学-心里商谈学部",
    "info": "B99_A4",
    "extra_info": "",
    "info2": "心理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C293",
    "name": "（只有大三）福利商谈学-社会福利学部",
    "info": "B99_A4",
    "extra_info": "",
    "info2": "社会福利学学士",
    "no_prerequisites": false
  },
  {
    "id": "C294",
    "name": "国际通商学",
    "info": "B37_A5",
    "extra_info": "52400元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C295",
    "name": "数据科学专业",
    "info": "B7_A5",
    "extra_info": "52400元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C296",
    "name": "多媒体设计",
    "info": "B5_A17",
    "extra_info": "22000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "name": "美容护理",
    "info": "",
    "extra_info": "美容保健学学士",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "name": "游戏工程",
    "info": "",
    "extra_info": "工程学学士",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "name": "电影影响",
    "info": "",
    "extra_info": "戏剧电影学学士",
    "info2": "",
    "no_prerequisites": false
  }
];
